module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "glasses2.2eb8a31a.svg" + "?" + Date.now();